import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import { TDataSeries } from "../../screen/Portfolios/File/Util/MapRatiosToGraph";
import graphTheme from "../../graphTheme";

export type TGraphDataChart = {
    walletName: string;
    contrato: string;
    period: string;
    ratio: string;
    data?: TDataSeries[];
}

type THighchartsReactCustomProps = {
    name: string;
    graphDataList?: TGraphDataChart[]
}

const HighchartsReactCustom: React.FC<THighchartsReactCustomProps> = (props) => {
    let title: string = 'Value';
    let percentage: string = '';
    const dataSeries = props?.graphDataList?.map((graphData: TGraphDataChart) => {
        if (graphData.ratio === 'linear_return' || graphData.ratio === 'volatility' || graphData.ratio === 'max_drawdown' || graphData.ratio === 'downside_deviation') {
            percentage = ' %'
        }

        return {
            name: graphData.walletName,
            data: graphData.data,
        }
    });

    // @ts-ignore
    Highcharts.setOptions(graphTheme);
    const optionsChart: Highcharts.Options = {
        title: {
            text: props.name
        },
        credits:
        {
            enabled: false,
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
            }
        },
        chart:
        {
            type: 'spline',
            backgroundColor: 'none',
            height: 450,
            width: null,

        
        },
        yAxis: {
            title: {
                text: title + percentage
            }
        },
        xAxis: {
            type: 'datetime',
            scrollbar: {
                enabled: true
            },            
        },
        series: dataSeries as Highcharts.SeriesOptionsType[],
        navigator: { enabled: true }
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={optionsChart}
            immutable={false}
            />
    )
}

export default HighchartsReactCustom;